import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { MobileCTA } from "./MobileCTA";

export function PublicLayout({ children }) {
    return (
        <div className="min-h-screen bg-teal-900 text-cream flex flex-col">
            <Navbar />
            <main className="flex-1 pt-16 pb-16 lg:pb-0">{children}</main>
            <Footer />
            <MobileCTA />
        </div>
    );
}
